import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { includes } from 'lodash';
import Sider from './Sider';

import Header from './Header';
import Subheader from './Subheader';
import Loader from 'components/Loader';
import StateStore from 'globalStates/Store';
import AppStore from 'context';
import useContextService from 'hooks/useContextService';
import SideBar from './SideBar';


const modulpaths = ['/crosswalk','/purchaseorder'];
const Next = () => {
  const location = useLocation();
  const { states, resetStates } = useContextService();
  const { loading } = states;

  useEffect(() => {
    const { pathname } = new URL(window.location.href);
    const hasPathChanged = !includes(pathname, '/purchaseorder');
    if (hasPathChanged) {
      resetStates('purchaseorder');
    }
  }, [location]);
 

  

  return (
    <>
      {(loading && !modulpaths.includes(location.pathname)) && <Loader opacity={0.01} color='black' />}
      <Outlet />
    </>
  );
};

const Layout = (props) => {
  const { modules, onlOrgChange } = props;
  const [orgId, setOrgId] = useState(window.selectedOrganizationId);
  const [showchat, setShowChat] = useState(false);
  const [showChatboat, setShowChatboat] = useState(false);
  const [isRendered, setIsRendered] = useState(false);
  const [isTogglingPosition, setIsTogglingPosition] = useState(false);

  const [chatbotOpen, setChatbotOpen] = useState(false);
  const [addClass, setAddClass] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [sideExpand, setSideExpand] = useState(false);
  const onOrgChange = (orgId) => {
    setOrgId(orgId);
    onlOrgChange(orgId)
  }
  useEffect(() => {
    const { access_token } =
      JSON.parse(localStorage.getItem("pharmaforce")) || {};
    let userRoles = [];
    if (access_token) {
      let jwtData = access_token.split(".")[1];
      let decodedJwtJsonData = window.atob(jwtData);
      let decodedJwtData = JSON.parse(decodedJwtJsonData);
      userRoles = decodedJwtData["roles"];
      if (Array.isArray(userRoles)) {
        let hasAIARole = userRoles.includes("AIA");
        if (hasAIARole) {
          setShowChatboat(true);
        }
      }
    }
  }, []);
  const handelSubmit = async () => {
    // e.preventDefalut();
    if (feedmsg === "") {
      return;
    }
    if (Chatname == "") {
      setChatList([]);
      setShowChatHistory(false);
      setNewChat(false);
    }
    setLoad(true);
    setShowChatHistory(true);

    let datelabel = "Today";

    var item = {
      isAgent: true,
      message: feedmsg,
      msg_time: datelabel,
    };

    const findOrCreateDateEntry = (dateLabel) => {
      let entry = chatList.find((item) => item.date === datelabel);
      if (!entry) {
        entry = { date: dateLabel, history: [] };
        chatList.push(entry);
      }
      return entry;
    };

    // let msgDate = formatDate(new Date(item.msg_time));
    let dateLabel = "Today";

    findOrCreateDateEntry(dateLabel).history.push(item);
    setChatList([...chatList]);
    setFeedmsg("");
    setNewChat(false);

    try {
      let msg = new FormData();
      msg.append("user_message", feedmsg);
      msg.append("chat_name", Chatname ? Chatname : "");
      let streamedText = '';
      const finalRes = {
        message: '',
        isAgent: false
      };
      const response = await API.post(`/chat/stream_response/${activeId}`, msg, {
        responseType: 'text',
        haschatApiurl: true,
      });
      const chatNameFromHeader = response.headers['x-chat-name'];
      // console.log(chatNameFromHeader, "chatNameFromHeader");
      if (chatNameFromHeader) {
        setChatNameHeader(chatNameFromHeader);
      }

      const allLines = response.data.split('\n');
      let accumulatedText = '';
      const streamLineByLine = (index) => {
        if (index >= allLines.length) return;
        const nextChunk = allLines.slice(index, index + 5).join('\n');
        accumulatedText += (accumulatedText ? '\n' : '') + nextChunk;
        setVisibleText(accumulatedText);
        finalRes.message = accumulatedText
        setTimeout(() =>


          streamLineByLine(index + 5), 300

        );
      };

      streamLineByLine(0);
      chatList.map(((item) => item.history.push(finalRes)));
      setChatList([...chatList]);
      hideloading = true;
      setQuery("");
      setQuestions([]);
      setIsQuestionHidden(true);
      reloadChat();
    } catch (error) {
      setFeedmsg("");
      setLoad(false);
      setMessageIndex(0);
    }

  };

  const onClick = () => {
    if (!showchat) {
      setIsRendered(true);
      setChatbotOpen(!chatbotOpen);
      setAddClass(false);
      setTimeout(() => {
        setShowChat(true);
        setIsTogglingPosition(false);
      }, 0);

    } else {
      setShowChat(false);
      setShowSearch(true);
      setIsTogglingPosition(false);
      setAddClass(false);
      setTimeout(() => {
        setIsRendered(false);
        setChatbotOpen(!chatbotOpen);
        if (!showchat) {
          setSideExpand(false)
        }
      }, 400);
    }
  };
  return (
    <AppStore>
      <StateStore>
        <section>
          <Header 
          onOrgChange={onOrgChange} 
          isRendered={isRendered}
            isTogglingPosition={isTogglingPosition}
            setIsRendered={setIsRendered}
            setIsTogglingPosition={setIsTogglingPosition}
            onClick={onClick}
            showChatboat={showChatboat}
            addClass={addClass}
            setAddClass={setAddClass}
            showchat={showchat}
            setShowChat={setShowChat}
            setChatbotOpen={setChatbotOpen}
            chatbotOpen={chatbotOpen}
            setShowSearch={setShowSearch}
            showSearch={showSearch}
            sideExpand={sideExpand}
            setSideExpand={setSideExpand}
          />
          <div className='main-gird'>
            {/* <Subheader/> */}
            {/* <SideBar/> */}
            <SideBar />
            <div className='bg-light'>
              <Next />
            </div>
          </div>
        </section>
      </StateStore>
    </AppStore>
  );
};

export default Layout;
